export default __webpack_public_path__ + "static/media/product_placeholder.ab4f761e.jpg";